import { render, staticRenderFns } from "./modalAplicante.vue?vue&type=template&id=68bf38ea"
import script from "./modalAplicante.vue?vue&type=script&lang=js"
export * from "./modalAplicante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports